// Custom hook to load and update session information.
import { setSessionInfo, setTenantIsStale } from 'actions';
import { Session } from 'application/Shared/types/session';
import { State } from 'application/Shared/types/state';

/*  React  */
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const useSession = () => useSelector((state: State) => state.session);

export const useUpdateSession = () => {
    const dispatch = useDispatch();
    return useCallback(
        (sessionInfo: Session | null) => dispatch(setSessionInfo(sessionInfo)),
        [dispatch]
    );
};

export const useSetTenantIsStale = () => {
    const dispatch = useDispatch();
    return useCallback(
        (tenantId: string | undefined) => dispatch(setTenantIsStale(tenantId)),
        [dispatch]
    );
};
